import * as CryptoJS from 'crypto-js';
const OBJ_ENC_KEY = "7061737323313288";

export function encrypt(password) {

  var key = CryptoJS.enc.Utf8.parse('7061737323313233');
  var iv = CryptoJS.enc.Utf8.parse('7061737323313233');
  var encryptedPass = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(password), key,
    {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();

  return encryptedPass;
}

export function decryptData(data) {
  var key = CryptoJS.enc.Utf8.parse('7061737323313233');
  try {
    const bytes = CryptoJS.AES.decrypt(data, key);
    if (bytes.toString()) {
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    return data;
  } catch (e) {
    console.log(e);
  }
}

export function decrypt(ciphertext) {

  var key2 = CryptoJS.enc.Utf8.parse('7061737323313233');
  var iv2 = CryptoJS.enc.Utf8.parse('7061737323313233');

  let plainText = CryptoJS.AES.decrypt(ciphertext,
    key2,
    {
      keySize: 128 / 8,
      iv: iv2,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  return plainText;

}

export function encryptObj(obj) {
  return CryptoJS.AES.encrypt(obj, OBJ_ENC_KEY);
}

export function decryptObj(ciphertext) {

  if (!ciphertext)
    return null;

  var bytes = CryptoJS.AES.decrypt(ciphertext.toString(), OBJ_ENC_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
}